import Roles from '@/shared/utils/roles'

// Fluxo do `PUT DespesasDiversos/Reprove` decidido pela ETAPA da despesa, com o perfil como guarda.
// Antes o Fluxo saia do ultimo `hasRole` (tecnico vencia sempre): quem tinha mais de um perfil
// reprovava despesa de outra etapa, o backend nao casava o Fluxo com o status e nada acontecia
// (task 051). Mesma regra da reprovacao em lote (`modalEscolhaReprova`).
// statusDespesa: 2 = AG. APROVACAO CONTROLADORIA, 1 = AG. APROVACAO COORDENADOR, 9 = AG. APROVACAO TECNICO.
// Devolve null quando o usuario nao pode reprovar a despesa nessa etapa.
export const fluxoReprovacao = (statusDespesa, hasRole) => {
  if (statusDespesa === 2 && (hasRole(Roles.RW_REAL_ESTA_ADMIN) || hasRole(Roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL))) return 2
  if (statusDespesa === 1 && hasRole(Roles.ACC_FIN_MISCELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL)) return 1
  if (statusDespesa === 9 && hasRole(Roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL)) return 0
  return null
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/fluxoReprovacaoDiversos.js